import { inject, observer } from 'mobx-react';
import * as React from 'react';
import type ProviderStore from '../stores/provider-store';

interface IProps {
  providerStore?: ProviderStore;
}

@inject('providerStore')
@observer
class Manifest extends React.Component<IProps> {
  UNSAFE_componentWillMount() {
    this.createManifest();
  }

  render() {
    return null;
  }

  private createManifest(): void {
    const { origin } = window.location;
    const { appIconUrl, customColourPrimary, siteTitle } = this.props.providerStore!;
    const appIcon = !!appIconUrl ? `${origin}/api/online/files/bypath/${appIconUrl}` : null;
    let manifest = {
      name: siteTitle,
      short_name: siteTitle,
      scope: origin,
      start_url: origin,
      display: 'standalone',
      background_color: customColourPrimary,
      theme_color: customColourPrimary,
      icons: []
    };

    if (!!appIcon) {
      manifest.icons = [
        {
          purpose: 'any',
          src: appIcon,
          sizes: '144x144 192x192 256x256 512x512'
        },
        {
          purpose: 'any',
          src: appIcon,
          sizes: '64x64 96x96 128x128'
        }
      ];
    }

    const stringManifest = JSON.stringify(manifest);
    const blob = new Blob([stringManifest], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(blob);

    const manifestEl = document.getElementById('connect-manifest');
    if (!!manifestEl) {
      manifestEl.setAttribute('href', manifestURL);
    }

    const appleEl = document.getElementById('apple-icon');
    if (!!appleEl) {
      appleEl.setAttribute('href', appIcon);
    }
  }
}

export default Manifest;
